<div class="content-block light-control-host" id="application-creator-content">
  @if (loading) {
    <div>
      <h1><i class="fa-solid fa-spinner fa-spin"></i> {{ loadingText }}</h1>
    </div>
  } @else {
    <div id="connect-page-header" class="header-container">
      <div>
        <h1>Let's get connected</h1>
        @if (applicationType === 'aws') {
          <p class="header-description">
            @if (stackSetsEnabled) {
              Follow the StackSets instructions below to deploy access across your AWS accounts.
            } @else {
              To replicate your primary environment to your recovery region, {{ uiService.productName }} needs limited
              access to your AWS accounts. This is easily accomplished by installing these CloudFormation templates.
            }
          </p>
        }
        @if (applicationType === 'azure') {
          <p class="header-description">
            To replicate your primary environment to your recovery region, {{ uiService.productName }} needs limited
            access to your Azure subscriptions. This is easily accomplished by installing these Azure Resource Manager
            templates.
          </p>
        }
      </div>
      <div class="flex-center-row form-controls">
        <button type="button" class="arpio-secondary-button" (click)="backButtonClick()">BACK</button>
        <button
          type="button"
          class="arpio-button margin-left"
          [disabled]="!accessConfigured"
          (click)="continueButtonClick()"
        >
          CONTINUE
        </button>
      </div>
    </div>
    @if (applicationType === 'aws') {
      <!-- CloudFormation templates - ONLY when StackSets NOT enabled -->
      @if (!stackSetsEnabled) {
        <aws-account-access-view
          class="margin-top"
          [state]="sourceAccessService.state"
          [stackName]="sourceAccessService.stack"
          [accessType]="Scope.SOURCE"
          [templateUrl]="sourceAccessTemplate"
          [awsAccountId]="sourceAccountId"
          [region]="sourceRegion"
          [completedTestCount]="sourceAccessService.tests"
          [stickyReferenceId]="'connect-page-header'"
          (buttonClicked)="sourceAccessService.validateAccess()"
        >
        </aws-account-access-view>
        <aws-account-access-view
          class="margin-top"
          [state]="targetAccessService.state"
          [stackName]="targetAccessService.stack"
          [accessType]="Scope.TARGET"
          [templateUrl]="targetAccessTemplate"
          [awsAccountId]="targetAccountId"
          [region]="targetRegion"
          [completedTestCount]="targetAccessService.tests"
          [stickyReferenceId]="'connect-page-header'"
          (buttonClicked)="targetAccessService.validateAccess()"
        >
        </aws-account-access-view>
      }
      <!-- StackSets instructions - ONLY when StackSets enabled -->
      @if (stackSetsEnabled) {
        <!-- Both endpoints already managed by StackSets — skip the 3-step setup
        and let the update-only component handle anything left to do. -->
        @if (stackSetsSetupComplete) {
          <stacksets-update-instructions
            class="margin-top"
            [sourceStackSetTemplateUrl]="sourceStackSetTemplateUrl"
            [targetStackSetTemplateUrl]="targetStackSetTemplateUrl"
            [sourceAccountId]="sourceAccountId"
            [sourceRegion]="sourceRegion"
            [targetAccountId]="targetAccountId"
            [targetRegion]="targetRegion"
            [sourceStackName]="sourceAccessService?.stack"
            [targetStackName]="targetAccessService?.stack"
            [sourceManagedByStackSet]="sourceAccessService?.managedByStackSet"
            [targetManagedByStackSet]="targetAccessService?.managedByStackSet"
            [sourceAccessState]="sourceAccessService?.state"
            [targetAccessState]="targetAccessService?.state"
            [sourceTestCount]="sourceAccessService?.tests"
            [targetTestCount]="targetAccessService?.tests"
            [arpioAccountId]="accountId"
            [regenerationJobId]="regenerationJobId"
            (testAccess)="onTestAccess($event)"
          ></stacksets-update-instructions>
        } @else {
          <stacksets-instructions
            class="margin-top"
            [sourceStackSetTemplateUrl]="sourceStackSetTemplateUrl"
            [targetStackSetTemplateUrl]="targetStackSetTemplateUrl"
            [sourceTemplateBucket]="sourceTemplateBucket"
            [sourceTemplateKey]="sourceTemplateKey"
            [targetTemplateBucket]="targetTemplateBucket"
            [targetTemplateKey]="targetTemplateKey"
            [sourceAccountId]="sourceAccountId"
            [sourceRegion]="sourceRegion"
            [targetAccountId]="targetAccountId"
            [targetRegion]="targetRegion"
            [sourceStackName]="sourceAccessService?.stack"
            [targetStackName]="targetAccessService?.stack"
            [sourceManagedByStackSet]="sourceAccessService?.managedByStackSet"
            [targetManagedByStackSet]="targetAccessService?.managedByStackSet"
            [stickyReferenceId]="'connect-page-header'"
            [testingSource]="isTestingSourceAccess"
            [testingTarget]="isTestingTargetAccess"
            [sourceError]="sourceAccessService?.hasApiError"
            [targetError]="targetAccessService?.hasApiError"
            [sourceTestCount]="sourceAccessService?.tests"
            [targetTestCount]="targetAccessService?.tests"
            [arpioAccountId]="accountId"
            [regenerationJobId]="regenerationJobId"
            (testAccess)="onTestAccess($event)"
          ></stacksets-instructions>
        }
      }
    }
    @if (applicationType === 'azure') {
      <azure-access-view
        class="margin-top"
        [state]="targetAccessService.state"
        [accessType]="Scope.TARGET"
        [installCommand]="targetInstallCommand"
        [subscriptionId]="targetAccountId"
        [region]="targetRegion"
        [completedTestCount]="targetAccessService.tests"
        (buttonClicked)="targetAccessService.validateAccess()"
      >
      </azure-access-view>
      @if (!targetAccessService.allGood) {
        <div class="pending-notice margin-top">
          <i class="fa-solid fa-circle-info"></i>
          <span>Complete the recovery environment setup above before configuring the primary environment.</span>
        </div>
      }
      <azure-access-view
        class="margin-top"
        [class.disabled-pending]="!targetAccessService.allGood"
        [state]="sourceAccessService.state"
        [accessType]="Scope.SOURCE"
        [installCommand]="sourceInstallCommand"
        [subscriptionId]="sourceAccountId"
        [region]="sourceRegion"
        [completedTestCount]="sourceAccessService.tests"
        (buttonClicked)="sourceAccessService.validateAccess()"
      >
      </azure-access-view>
    }
  }
</div>
